
import { Component, Mixins, Prop, Ref, Emit, Watch } from "vue-property-decorator";
import AuthMixin from "../mixins/auth.mixin";
import { IUser, UserLevel, UserLevels } from "shared/entities/user";
import { UpdateUserRequest } from "shared/api/routes/user";
import { BModal } from "bootstrap-vue";
import { apiHandler } from "@/services/api-handler";
import { Api } from "shared/api";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { ILocation } from "shared/entities/location";

@Component({
    components: { VueTypeaheadBootstrap, BModal }
})
export default class EditUser extends Mixins(AuthMixin) {
    editUserProps: UpdateUserRequest = {
        locationIds: [],
        firstName: "",
        lastName: "",
        email: "",
        level: UserLevel.Employee,
        ownerId: undefined
    };

    editUserOriginal?: IUser;
    selectedLocationIds: number[] = [];
    localLocations: ILocation[] = [];

    @Prop({ required: true }) readonly owners!: IUser[];

    @Prop({ required: true }) readonly locations!: ILocation[];

    @Ref()
    private readonly editUserModel!: BModal;

    UserLevel = UserLevel;

    @Watch("locations", { immediate: true, deep: true })
    onLocationsChanged(newVal: ILocation[]) {
        this.localLocations = [...newVal];
    }

    async created() {
        this.localLocations = [...this.locations];
    }

    get levels() {
        if (this.user?.level !== UserLevel.Admin) {
            return UserLevels.filter(level => level < (this.user?.level ?? 0)).map(level => ({ level, title: UserLevel[level] }));
        } else {
            return UserLevels.map(level => ({ level, title: UserLevel[level] }));
        }
    }

    @Emit("finished")
    private finished(user: IUser): IUser {
        this.editUserModel.hide();
        return user;
    }

    async editUser() {
        if (this.editUserOriginal === undefined) return;
        const id = this.editUserOriginal.id;
        const toSend: UpdateUserRequest = {
            locationIds: this.selectedLocationIds,
            ownerId: this.editUserProps.ownerId
        };
        if (this.editUserOriginal.firstName !== this.editUserProps.firstName) toSend.firstName = this.editUserProps.firstName;
        if (this.editUserOriginal.lastName !== this.editUserProps.lastName) toSend.lastName = this.editUserProps.lastName;
        if (this.editUserOriginal.email !== this.editUserProps.email) toSend.email = this.editUserProps.email;
        if (this.editUserOriginal.level !== this.editUserProps.level) toSend.level = this.editUserProps.level;

        const result = await apiHandler(() => Api.user[id].Patch(toSend));
        if (result.valid) this.finished(result.user);
        else alert(result.error);
        alert("User Updated");
        this.editUserOriginal = undefined;
        this.editUserProps = { locationIds: [], firstName: "", lastName: "", email: "", level: UserLevel.Employee, ownerId: undefined };
    }

    public show(user: IUser) {
        this.selectedLocationIds = user.locations ? user.locations.map(loc => loc.id) : [];
        this.editUserProps = {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            locationIds: this.selectedLocationIds,
            level: user.level,
            ownerId: user.owner ? user.owner.id : undefined
        };
        this.editUserOriginal = { ...user };
        this.editUserModel.show();
    }
}
